import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../services/api/auth/auth.service';
import { selectUser } from '../../../store/auth/auth.selectors';
import { AppState } from '../../../store/app.state';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

export const permissionGuard = (requiredPermissions: string[] = []): CanActivateFn => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store = inject(Store<AppState>);
    const router = inject(Router);

    return store.select(selectUser).pipe(
      take(1),
      map((user) => {
        if (!user) {
          router.navigate(['/login']);
          return false;
        }

        const hasPermission = user.permissions?.some((perm) => requiredPermissions.includes(perm));

        if (!hasPermission) {
          router.navigate(['/unauthorized']);
          return false;
        }

        return true;
      })
    );
  };
};
